import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronUpOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m12 6-8 8 1.273 1.273L12 8.546l6.727 6.727L20 14z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronUpOutlinedSize24Glyph.displayName = 'ChevronUpOutlinedSize24Glyph';
